import React from 'react';
import { cn } from '@/lib/utils';
import { PublicFooter } from './PublicFooter';

/**
 * Wrapper for public-facing pages — flex column with optional footer variant.
 * Do not use on logged-in archive workspace pages.
 */
export function PublicLayout({
  children,
  className,
  footerVariant = 'full',
  hideFooter = false,
  showPreFooterCta = false,
  onStartArchive,
}) {
  return (
    <div className={cn('flex min-h-screen flex-col', className)}>
      {children}
      {!hideFooter ? (
        <PublicFooter
          variant={footerVariant}
          showPreFooterCta={showPreFooterCta}
          onStartArchive={onStartArchive}
        />
      ) : null}
    </div>
  );
}

export default PublicLayout;
